/**
 * Collection card badges (image badges, sale badges, discount codes/badges).
 *
 * Two render pipelines feed this decorator:
 *   1. Globo Filter & Search (US/CA/AU) — fires `globoFilterRenderCompleted`
 *      on `window` and re-renders Dawn/Globo cards (`.card-wrapper[data-product-handle]`).
 *   2. Fitfindo (EU) — fires `fitfindo:rendered` on `document` with
 *      `detail.grid` and re-renders `.ff-card` divs (handle lives on `.ff-card-link`).
 *
 * Both re-fire on every filter/sort/search, so all decoration is idempotent.
 * Config is provided by the theme via `window.themeBadgeConfig`
 * (see snippets/collection-card-badges-data.liquid).
 */
(function () {
  var logger = window.log || { debug: function () {} };

  function getConfig() {
    return window.themeBadgeConfig || {};
  }

  // Split a `themeBadgeConfig` delimited list into non-empty entries.
  function splitList(value) {
    return (value || '').split(';').filter(function (el) {
      return el !== '';
    });
  }

  /* ------------------------------------------------------------------ *
   * Globo pipeline (jQuery) — behaviour preserved from the original.
   * ------------------------------------------------------------------ */
  function decorateGloboGrid() {
    if (typeof window.jQuery === 'undefined') return;
    var $ = window.jQuery;
    var cfg = getConfig();
    var colorClass = 'color-' + (cfg.saleBadgeColorScheme || '');

    if (typeof globoswatch !== 'undefined') globoswatch.init();

    // Image badges
    var imageBadges = [];
    if (cfg.imageBadgesEnabled) {
      imageBadges = (cfg.imageBadges || '').split(';');
      $('.card--product').each(function () {
        $(this).append('<div class="image-badge-container--top-left"></div>');
        $(this).append('<div class="image-badge-container--top-right"></div>');
        $(this).append('<div class="image-badge-container--bottom-left"></div>');
        $(this).append('<div class="image-badge-container--bottom-right"></div>');
      });
    }

    $('.card-wrapper').each(function () {
      var productHandle = $(this).data('product-handle');
      if (!productHandle) return;
      imageBadges.forEach((imageBadge) => {
        if (!entryHasHandle(imageBadge, productHandle)) return;
        var imageBadgeAr = imageBadge.split(', ');
        var badgePosition = imageBadgeAr[4].toLowerCase().replace(' ', '-');
        var badgeDisableOnProductItems = imageBadgeAr[5];
        var badgeTitle = imageBadgeAr[0];
        var badgeImage = imageBadgeAr[1];
        if (badgeDisableOnProductItems != 'true') {
          var badgeHtml = `<div class="image-badge image-badge cst"><img src="${badgeImage}" alt="${badgeTitle}" width="48" height="48" loading="lazy"></div>`;
          $(this).find(`.card--product .image-badge-container--${badgePosition}`).append(badgeHtml);
        }
      });
    });

    // Sale badges
    if (cfg.saleBadgesEnabled) {
      var saleBadges = (cfg.saleBadges || '').split(';');
      saleBadges = saleBadges.filter((el) => el != '');

      $('.card-wrapper').each(function () {
        var productHandle = $(this).data('product-handle');
        $(this).find('.card__badge .badge--after-load').remove();

        saleBadges.forEach((badge) => {
          if (badge.includes(productHandle)) {
            var badgeAr = badge.split(', ');
            var badgeText = badgeAr[0];
            var textColor = badgeAr[4];
            var bgColor = badgeAr[5];
            var disableOther = badgeAr[6];
            var specialEventsOnly = badgeAr[7];
            var settings_special_events_enabled = cfg.specialEventsEnabled;
            var enableOnCollection = badgeAr[2];
            var display_badge = false;
            for (var i = 8; i < badgeAr.length; i++) {
              if (badgeAr[i] == productHandle) {
                display_badge = true;
              }
            }
            logger.debug('settings_special_events_enabled', settings_special_events_enabled);
            logger.debug('specialEventsOnly', specialEventsOnly);
            logger.debug('badgeText', badgeText);
            var badgeHtml = `<div class="badge badge--bottom-left badge--after-load ${colorClass} cst" style="color: ${textColor}; background-color: ${bgColor};">${badgeText}</div>`;
            logger.debug('enableOnCollection', enableOnCollection);
            if (display_badge == true) {
              if (specialEventsOnly == 'true' && settings_special_events_enabled == false) {
                return;
              }
              if (enableOnCollection == 'true' && disableOther == 'true') {
                $(this).find('.card__badge').html(badgeHtml);
              } else if (enableOnCollection == 'true') {
                $(this).find('.card__badge').append(badgeHtml);
              }
            }
          }
        });
      });
    }

    // Discount codes
    if (cfg.codeDiscountsEnabled) {
      var discountCodes = (cfg.discountCodes || '')
        .split(';')
        .map(function (entry) {
          return entry.trim();
        })
        .filter(Boolean);
      logger.debug(discountCodes);

      $('.card-wrapper').each(function () {
        var price = $(this).find('.product-price').data('price');
        var compare_at_price = $(this).find('.product-price').data('compare-at-price');
        var priceVaries = $(this).find('.product-price').data('price-varies') == true ? '+' : '';

        discountCodes.forEach((discountCode) => {
          logger.debug(discountCode);
          if (discountCode.includes($(this).data('product-handle'))) {
            var discountCodeAr = discountCode.split(', ');
            var code = (discountCodeAr[0] || '').trim();
            var percentageDiscount = discountCodeAr[2];
            var valueDiscount = discountCodeAr[3] / 100;
            var enableBadge = discountCodeAr[4];
            var badgeText = discountCodeAr[5];
            var badgeBgColor = discountCodeAr[6];
            var badgeTextColor = discountCodeAr[7];
            var updatedPrice = price;

            if (percentageDiscount) {
              updatedPrice = price - (price * percentageDiscount) / 100;
            } else if (valueDiscount) {
              updatedPrice = price - valueDiscount;
            }

            var updatedCompareAtPrice = '';
            if (!compare_at_price) {
              updatedCompareAtPrice = Math.round(price * 100) / 100;
            } else {
              updatedCompareAtPrice = Math.round(compare_at_price * 100) / 100;
            }
            updatedPrice = updatedPrice.toFixed(2);
            updatedCompareAtPrice = updatedCompareAtPrice.toFixed(2);

            if (enableBadge == 'true') {
              var discountHtml = `<span class="badge badge--bottom-left badge--after-load ${colorClass} cst" style="background: ${badgeBgColor}; color: ${badgeTextColor};">${badgeText}</span>`;
              $(this).find('.card__badge').html(discountHtml);
            }
            var discountPrice = `<span class="price price-product__value "><span class="product-price_sale"><del class="product-price_compare"> $${updatedCompareAtPrice}</del><span class="product-lowest-price">$${updatedPrice}${priceVaries}</span> <span class="code-discount-text-coll">${withCodeText(cfg, code)}</span></span></span>`;
            $(this).find('.product-price').html(discountPrice);
          }
        });
      });
    }

    // Discount metaobject badges
    if (cfg.discountsEnabled) {
      var discountBadgeItems = (cfg.discountBadgeItems || '').split(';');

      $('.card-wrapper').each(function () {
        var productHandle = $(this).data('product-handle');
        discountBadgeItems.forEach((discountBadgeItem) => {
          var display_badge = false;
          if (discountBadgeItem.includes(productHandle)) {
            var discountBadgeItemAr = discountBadgeItem.split(', ');
            for (var i = 2; i < discountBadgeItemAr.length; i++) {
              if (discountBadgeItemAr[i] == productHandle) {
                display_badge = true;
              }
            }
            if (display_badge == true && discountBadgeItemAr[0] == 'true') {
              var discountBadge = `<span class="discount_off_text">${discountBadgeItemAr[1]}</span>`;
              if ($(this).find('.product-price .discount_off_text').length <= 0) {
                $(this).find('.product-price').append(discountBadge);
              }
            }
          }
        });
      });
    }
  }

  /* ------------------------------------------------------------------ *
   * Fitfindo pipeline (vanilla) — decorates `.ff-card` divs.
   * ------------------------------------------------------------------ */

  // Fitfindo cards are divs; the product URL lives on `.ff-card-link`.
  function handleFromCard(card) {
    var link = card.querySelector('.ff-card-link') || card.querySelector('a[href*="/products/"]');
    var href = (link && link.getAttribute('href')) || card.getAttribute('href') || '';
    var match = href.match(/\/products\/([^/?#]+)/);
    if (!match) return '';
    try {
      return decodeURIComponent(match[1]);
    } catch (e) {
      return match[1];
    }
  }

  // Fitfindo's display group id; on EU every card is one product, so this is the product ID.
  function productIdFromCard(card) {
    return card.getAttribute('data-group-id') || '';
  }

  // [[code, [productId, …]], …] → true when the code is assigned to this product.
  function codeHasProduct(cfg, code, productId) {
    if (!productId) return false;
    return (cfg.discountCodeProductIds || []).some(function (pair) {
      return pair[0] === code && (pair[1] || []).some(function (id) {
        return String(id) === productId;
      });
    });
  }

  function withCodeText(cfg, code) {
    var text = cfg.withCodeText || "with code: '__CODE__'";
    return text.replace('__CODE__', code);
  }

  function entryHasHandle(entry, handle) {
    if (!handle) return false;
    var needle = String(handle).trim();
    if (!needle) return false;
    var parts = entry.split(', ');
    for (var i = 0; i < parts.length; i++) {
      if (parts[i].trim() === needle) return true;
    }
    return false;
  }

  // Read "EUR 199.00" / "€ 1,249.00" / "1.249,00 €" / "1 249,00 €" into an amount plus the
  // storefront's own format (currency position, decimal and thousands separators), so a
  // rewritten price looks like the original on every locale.
  // Fitfindo sale cards append savings copy inside the same node
  // ("EUR 479.00Up to EUR 100.00 Off") — strip that before parsing so it
  // is never treated as part of the currency label.
  function parseFfPrice(text) {
    var raw = (text || '').replace(/[\u00a0\u202f]/g, ' ').trim();
    raw = raw
      .replace(/\b(?:up\s+to\s+)?(?:[A-Z]{3}\s*)?[€$£¥]?\s*[\d.,]+\s*%?\s*off\b/gi, ' ')
      .replace(/\s+/g, ' ')
      .trim();

    var match = raw.match(/\d[\d., ]*\d|\d/);
    if (!match) return null;
    var number = match[0];
    var decimal = /[.,]\d{2}$/.test(number) ? number.charAt(number.length - 3) : '';
    var whole = decimal ? number.slice(0, -3) : number;
    var digits = number.replace(/\D/g, '');
    var amount = decimal ? parseInt(digits, 10) / 100 : parseInt(digits, 10);
    if (isNaN(amount)) return null;

    var thousands = (whole.match(/[., ]/) || [''])[0];
    if (!thousands) {
      try {
        var group = new Intl.NumberFormat(document.documentElement.lang || undefined).formatToParts(1000).find(function (part) {
          return part.type === 'group';
        });
        thousands = group ? group.value.replace(/[\u00a0\u202f]/, ' ') : '';
      } catch (e) {
        thousands = '';
      }
    }

    // Keep only the currency label next to the number, never trailing copy.
    var prefix = (raw.slice(0, match.index).match(/(?:[A-Z]{3}|[€$£¥]|zł|kr) ?$/i) || [''])[0];
    var suffix = (raw.slice(match.index + number.length).match(/^ ?(?:[A-Z]{3}\b|[€$£¥]|zł|kr)/i) || [''])[0];
    if (/^ ?up\b/i.test(suffix)) suffix = '';

    return {
      source: prefix + number + suffix,
      prefix: prefix.replace(/ /g, '\u00a0'),
      suffix: suffix.replace(/ /g, '\u00a0'),
      decimal: decimal,
      thousands: thousands.replace(/ /g, '\u00a0'),
      amount: amount
    };
  }

  function formatFfPrice(parsed, amount) {
    var fixed = parsed.decimal ? amount.toFixed(2) : String(Math.round(amount));
    var parts = fixed.split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, parsed.thousands);
    return parsed.prefix + (parsed.decimal ? whole + parsed.decimal + parts[1] : whole) + parsed.suffix;
  }

  // Prefer structured Fitfindo price nodes; fall back to cleaned textContent.
  function readFfBasePrice(priceEl) {
    if (priceEl.dataset.ffBasePrice) {
      return parseFfPrice(priceEl.dataset.ffBasePrice);
    }

    var compare = priceEl.querySelector('.ff-price-compare, del, s');
    var sale = priceEl.querySelector('.ff-price-sale, .product-lowest-price');
    var source = compare || sale || priceEl;
    var clone = source.cloneNode(true);
    clone.querySelectorAll('.ff-price-savings, .discount-display, .code-discount-text-coll, .discount_off_text').forEach(function (node) {
      node.remove();
    });

    var parsed = parseFfPrice(clone.textContent);
    if (parsed) {
      priceEl.dataset.ffBasePrice = parsed.source;
    }
    return parsed;
  }

  function ensureFfBadgeHost(card) {
    var host = card.querySelector('.ff-badge-host');
    if (host) return host;

    host = document.createElement('div');
    host.className = 'ff-badge-host';

    var img = card.querySelector('.ff-card-img');
    if (img && img.parentNode) {
      img.parentNode.insertBefore(host, img);
      host.appendChild(img);
    } else {
      card.insertBefore(host, card.firstChild);
    }
    return host;
  }

  function ensureFfBadgeContainer(card) {
    var host = ensureFfBadgeHost(card);
    var container = host.querySelector('.card__badge');
    if (!container) {
      container = document.createElement('div');
      container.className = 'card__badge ff-card-badge';
      host.insertBefore(container, host.firstChild);
    }
    return container;
  }

  function ensureFfImageContainers(card) {
    var host = ensureFfBadgeHost(card);
    if (host.dataset.imageBadgeContainers === 'true') return host;
    ['top-left', 'top-right', 'bottom-left', 'bottom-right'].forEach(function (pos) {
      var el = document.createElement('div');
      el.className = 'image-badge-container--' + pos;
      host.appendChild(el);
    });
    host.dataset.imageBadgeContainers = 'true';
    return host;
  }

  function decorateFfImageBadges(cards, cfg) {
    if (!cfg.imageBadgesEnabled) return;
    var imageBadges = (cfg.imageBadges || '').split(';');

    cards.forEach(function (card) {
      var host = ensureFfImageContainers(card);
      // Clear any prior badges (idempotent across re-renders).
      host.querySelectorAll('.image-badge-container--top-left .image-badge, .image-badge-container--top-right .image-badge, .image-badge-container--bottom-left .image-badge, .image-badge-container--bottom-right .image-badge').forEach(function (el) {
        el.remove();
      });

      var handle = handleFromCard(card);
      if (!handle) return;
      imageBadges.forEach(function (imageBadge) {
        if (!entryHasHandle(imageBadge, handle)) return;
        var ar = imageBadge.split(', ');
        var position = (ar[4] || '').toLowerCase().replace(' ', '-');
        var disableOnProductItems = ar[5];
        var title = ar[0];
        var image = ar[1];
        if (disableOnProductItems === 'true') return;
        var target = host.querySelector('.image-badge-container--' + position);
        if (!target || !image) return;
        var wrapper = document.createElement('div');
        wrapper.className = 'image-badge image-badge cst';
        wrapper.innerHTML = '<img src="' + image + '" alt="' + title + '" width="48" height="48" loading="lazy">';
        target.appendChild(wrapper);
      });
    });
  }

  function isFfSoldOut(card) {
    return !!card.querySelector('.ff-avail--out_of_stock, .ff-avail--sold_out');
  }

  function isFfOnSale(card) {
    var priceEl = card.querySelector('.ff-card-price');
    if (!priceEl) return false;
    return !!priceEl.querySelector('.ff-price-compare, del, s');
  }

  function appendNativeBadge(container, className, label) {
    var el = document.createElement('span');
    el.className = 'badge badge--bottom-left badge--native ' + className;
    el.setAttribute('aria-hidden', 'true');
    el.textContent = label;
    container.insertBefore(el, container.firstChild);
  }

  // Dawn `.card__badge` overlays (Sold Out / Sale) are Liquid-only on
  // theme cards. Fitfindo cards have no Liquid, so rebuild them from the
  // widget's availability + compare-at price markup.
  function decorateFfNativeBadges(cards, cfg) {
    var soldOutClass = 'color-' + (cfg.soldOutBadgeColorScheme || 'inverse');
    var saleClass = 'color-' + (cfg.saleBadgeColorScheme || '');
    var soldOutLabel = cfg.soldOutLabel || 'Sold Out';
    var onSaleLabel = cfg.onSaleLabel || 'Sale';

    cards.forEach(function (card) {
      var container = ensureFfBadgeContainer(card);
      container.querySelectorAll('.badge--native').forEach(function (el) {
        el.remove();
      });

      if (isFfSoldOut(card)) {
        appendNativeBadge(container, soldOutClass, soldOutLabel);
      } else if (isFfOnSale(card) && !container.querySelector('.ff-code-badge')) {
        // A code-discount badge already says "Sale"; Omnibus refs can land after it.
        appendNativeBadge(container, saleClass, onSaleLabel);
      }
    });
  }

  function decorateFfSaleBadges(cards, cfg, colorClass) {
    if (!cfg.saleBadgesEnabled) return;
    // Blank entries dropped so the index lines up with saleBadgeProductIds (one per metaobject).
    var saleBadges = splitList(cfg.saleBadges).filter(function (el) {
      return el.trim() !== '';
    });
    var saleBadgeProductIds = cfg.saleBadgeProductIds || [];

    cards.forEach(function (card) {
      var handle = handleFromCard(card);
      var productId = productIdFromCard(card);
      var container = ensureFfBadgeContainer(card);
      container.querySelectorAll('.badge--after-load').forEach(function (el) {
        el.remove();
      });

      saleBadges.forEach(function (badge, index) {
        var hasId =
          !!productId &&
          (saleBadgeProductIds[index] || []).some(function (id) {
            return String(id) === productId;
          });
        if (!hasId && !entryHasHandle(badge, handle)) return;
        var ar = badge.split(', ');
        var badgeText = ar[0];
        var enableOnCollection = ar[2];
        var textColor = ar[4];
        var bgColor = ar[5];
        var disableOther = ar[6];
        var specialEventsOnly = ar[7];
        if (specialEventsOnly === 'true' && cfg.specialEventsEnabled === false) return;
        if (enableOnCollection !== 'true') return;

        var badgeHtml =
          '<div class="badge badge--bottom-left badge--after-load ' +
          colorClass +
          ' cst" style="color: ' +
          textColor +
          '; background-color: ' +
          bgColor +
          ';">' +
          badgeText +
          '</div>';
        if (disableOther === 'true') {
          container.innerHTML = badgeHtml;
        } else {
          container.insertAdjacentHTML('beforeend', badgeHtml);
        }
      });
    });
  }

  // Cheapest available variant among a Fitfindo result's matched variants (cheapest overall when none is
  // available), as the engine prices cards with layout card_price_from = cheapest. The engine's own pick
  // (price_product_id) wins when it sends one.
  function pricedVariantOf(result) {
    if (!result) return '';
    if (result.price_product_id) return String(result.price_product_id);
    var variants = [{ product_id: result.product_id, price_amount: result.price_amount, availability: result.availability }]
      .concat(result.siblings || []);
    var available = variants.filter(function (v) {
      return v.availability !== 'out_of_stock';
    });
    var pool = available.length ? available : variants;
    var cheapest = pool[0];
    pool.forEach(function (v) {
      if (v.price_amount < cheapest.price_amount) cheapest = v;
    });
    return cheapest ? String(cheapest.product_id) : '';
  }

  function markPricedVariants(cards, results) {
    if (!results) return;
    var byGroup = {};
    results.forEach(function (r) {
      if (r && r.display_group_id != null) byGroup[r.display_group_id] = r;
    });
    cards.forEach(function (card) {
      var r = byGroup[card.getAttribute('data-group-id')];
      if (r) card.dataset.pricedVariantId = pricedVariantOf(r);
    });
  }

  // Live price + Omnibus 30-day low of one variant, in the cart currency ({p, low}, cents), from
  // templates/product.code-price.liquid. Cached per variant for the page.
  var variantCodePrices = {};
  function loadVariantCodePrice(card, variantId) {
    if (!variantId) return Promise.resolve(null);
    if (variantCodePrices[variantId]) return variantCodePrices[variantId];
    var link = card.querySelector('.ff-card-link') || card.querySelector('a[href*="/products/"]');
    if (!link) return Promise.resolve(null);
    var url = new URL(link.getAttribute('href'), window.location.origin);
    url.search = '';
    url.searchParams.set('variant', variantId);
    url.searchParams.set('view', 'code-price');
    variantCodePrices[variantId] = fetch(url.toString(), { credentials: 'same-origin' })
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(function (data) {
        return data && String(data.v) === String(variantId) ? data : null;
      })
      .catch(function () {
        delete variantCodePrices[variantId];
        return null;
      });
    return variantCodePrices[variantId];
  }

  function decorateFfCodeDiscounts(cards, cfg, colorClass) {
    if (!cfg.codeDiscountsEnabled) return;
    var discountCodes = (cfg.discountCodes || '')
      .split(';')
      .map(function (entry) {
        return entry.trim();
      })
      .filter(Boolean);

    cards.forEach(function (card) {
      var handle = handleFromCard(card);
      var productId = productIdFromCard(card);
      var priceEl = card.querySelector('.ff-card-price');
      if (!priceEl) return;

      discountCodes.forEach(function (discountCode) {
        var ar = discountCode.split(', ');
        var code = (ar[0] || '').trim();
        if (!codeHasProduct(cfg, code, productId) && !entryHasHandle(discountCode, handle)) return;
        var percentageDiscount = ar[2];
        // Fixed-amount codes are set in shop-currency cents; checkout converts them at Shopify's rate, rounded to the cent.
        var valueCents = Math.round(parseFloat(ar[3]) * (parseFloat(window.Shopify && window.Shopify.currencyRate) || 1));
        var enableBadge = ar[4];
        var badgeText = ar[5];
        var badgeBgColor = ar[6];
        var badgeTextColor = ar[7];

        var parsed = readFfBasePrice(priceEl);
        if (!parsed) return;

        if (enableBadge === 'true') {
          var container = ensureFfBadgeContainer(card);
          container.querySelectorAll('.badge--after-load').forEach(function (el) {
            el.remove();
          });
          if (!isFfSoldOut(card)) {
            container.querySelectorAll('.badge--native').forEach(function (el) {
              el.remove();
            });
          }
          container.insertAdjacentHTML(
            'beforeend',
            '<span class="badge badge--bottom-left badge--after-load ff-code-badge ' +
              colorClass +
              ' cst" style="background: ' +
              badgeBgColor +
              '; color: ' +
              badgeTextColor +
              ';">' +
              badgeText +
              '</span>'
          );
        }

        // The variant the card is priced from: the cheapest available one among the variants that match the
        // shopper's filters (pricedVariantId, set from Fitfindo's results). Unfiltered, that is the variant in
        // codePrices (snippets/card-price-variant.liquid), at its live price. Any other variant (a filtered grid)
        // is read live from templates/product.code-price.liquid: the card never quotes a variant the shopper
        // filtered out, and never Fitfindo's indexed price, which lags the exchange rate outside EUR.
        var live = (cfg.codePrices || {})[productId];
        // Before Fitfindo's results are at hand (script loaded after the render), the widget's own priced variant.
        var widgetPriced = card.dataset.priceVariantId !== card.dataset.productId ? card.dataset.priceVariantId : '';
        var pricedId = card.dataset.pricedVariantId || widgetPriced || '';
        var render = function (baseCents, lowCents) {
          var updatedCents = baseCents;
          if (percentageDiscount) {
            updatedCents = Math.round(baseCents - (baseCents * percentageDiscount) / 100);
          } else if (valueCents) {
            updatedCents = baseCents - valueCents;
          }
          // Omnibus: the struck price is that variant's 30-day low, only when it's above the code price; never the
          // regular price. "+" marks a "from" price when the variants' prices differ, as on the theme's cards.
          var was = lowCents > updatedCents ? lowCents : 0;
          priceEl.innerHTML =
            '<span class="product-price_sale">' +
            (was ? '<del class="product-price_compare">' + formatFfPrice(parsed, was / 100) + '</del>' : '') +
            '<span class="product-lowest-price">' +
            formatFfPrice(parsed, updatedCents / 100) +
            (live && live.m ? '+' : '') +
            '</span> <span class="code-discount-text-coll">' +
            withCodeText(cfg, code) +
            '</span></span>';
        };

        if (live && (!pricedId || pricedId === String(live.v))) {
          render(live.p, live.low);
        } else if (live) {
          // Fitfindo's own price until the matching variant's live price arrives; nothing struck meanwhile.
          render(Math.round(parsed.amount * 100), 0);
          loadVariantCodePrice(card, pricedId).then(function (data) {
            if (data && card.dataset.pricedVariantId === pricedId) render(data.p, data.low);
          });
        } else {
          render(Math.round(parsed.amount * 100), 0);
        }
      });
    });
  }

  // snippets/icon-discount.liquid, inlined because this runs in JS.
  var DISCOUNT_ICON =
    '<svg aria-hidden="true" focusable="false" class="icon icon-discount" viewBox="0 0 12 12">' +
    '<path fill-rule="evenodd" clip-rule="evenodd" d="M7 0h3a2 2 0 012 2v3a1 1 0 01-.3.7l-6 6a1 1 0 01-1.4 0l-4-4a1 1 0 010-1.4l6-6A1 1 0 017 0zm2 2a1 1 0 102 0 1 1 0 00-2 0z" fill="currentColor"></path></svg>';

  function decorateFfDiscountText(cards, cfg) {
    if (!cfg.discountsEnabled) return;
    var discountBadgeItems = (cfg.discountBadgeItems || '').split(';');

    cards.forEach(function (card) {
      var handle = handleFromCard(card);
      var productId = productIdFromCard(card);
      var priceEl = card.querySelector('.ff-card-price');
      if (!priceEl) return;

      discountBadgeItems.forEach(function (discountBadgeItem) {
        var ar = discountBadgeItem.split(', ');
        if (ar[0] !== 'true') return;
        if (!entryHasHandle(discountBadgeItem, productId) && !entryHasHandle(discountBadgeItem, handle)) return;
        if (card.querySelector('.discount_off_text')) return;
        // Same look as the product page badge: tag icon + text, next to the price.
        var span = document.createElement('span');
        span.className = 'discount_off_text';
        span.innerHTML = DISCOUNT_ICON;
        span.appendChild(document.createTextNode(ar[1]));
        priceEl.classList.add('ff-card-price--has-discount');
        priceEl.appendChild(span);
      });
    });
  }


  /* ------------------------------------------------------------------ *
   * Omnibus (EU, Q-316) — Fitfindo prints compare-at; the EU rule needs the
   * lowest price of the 30 days before the reduction instead. Refs come from
   * templates/collection.omnibus-refs.liquid ({ "<variant id>": cents }).
   * A card shows strike / savings / Sale only when its variant has a ref above
   * its price; everything else is shown at its plain price.
   * ------------------------------------------------------------------ */
  var OMNIBUS_TTL = 10 * 60 * 1000;
  var omnibusRefs = null;
  var omnibusRefsPromise = null;

  function omnibusOn(cfg) {
    return cfg.omnibusMode === true && !!cfg.omnibusRefsUrl;
  }

  function omnibusCurrency() {
    // Liquid's cart currency first: window.Shopify.currency is not set on every page (PLN read as EUR)
    return getConfig().omnibusCurrency || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
  }

  function omnibusCacheKey() {
    return 'deskyOmnibusRefs:' + ((window.Shopify && window.Shopify.country) || '') + ':' + omnibusCurrency();
  }

  function fetchOmnibusPage(url, page) {
    return fetch(url + '&page=' + page, { credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) throw new Error('omnibus refs ' + r.status);
      return r.json();
    });
  }

  function loadOmnibusRefs(cfg) {
    if (omnibusRefs) return Promise.resolve(omnibusRefs);
    if (omnibusRefsPromise) return omnibusRefsPromise;
    try {
      var cached = JSON.parse(sessionStorage.getItem(omnibusCacheKey()) || 'null');
      if (cached && Date.now() - cached.t < OMNIBUS_TTL && cached.refs) {
        omnibusRefs = cached.refs;
        return Promise.resolve(omnibusRefs);
      }
    } catch (e) {}

    omnibusRefsPromise = fetchOmnibusPage(cfg.omnibusRefsUrl, 1)
      .then(function (first) {
        var rest = [];
        for (var p = 2; p <= (first.pages || 1); p++) rest.push(fetchOmnibusPage(cfg.omnibusRefsUrl, p));
        return Promise.all(rest).then(function (pages) {
          var refs = {};
          [first].concat(pages).forEach(function (pg) {
            if (pg.cur && pg.cur !== omnibusCurrency()) return;
            Object.keys(pg.refs || {}).forEach(function (id) {
              refs[id] = pg.refs[id];
            });
          });
          return refs;
        });
      })
      .then(function (refs) {
        omnibusRefs = refs;
        try {
          sessionStorage.setItem(omnibusCacheKey(), JSON.stringify({ t: Date.now(), refs: refs }));
        } catch (e) {}
        return refs;
      })
      .catch(function (err) {
        // No refs = no reductions shown, which is the compliant fallback.
        logger.debug('[omnibus] refs failed', err);
        omnibusRefsPromise = null;
        return {};
      });
    return omnibusRefsPromise;
  }

  // Same formatting as the Fitfindo widget (Intl, page language).
  function formatOmnibusMoney(cents) {
    var cur = omnibusCurrency();
    var lang = (document.documentElement.lang || '').trim() || undefined;
    try {
      return new Intl.NumberFormat(lang, { style: 'currency', currency: cur }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2) + ' ' + cur;
    }
  }

  function omnibusSavingsText(ref, price) {
    var strings = window.__ffStrings || {};
    var off = ref - price;
    var pct = Math.round((off * 100) / ref);
    // The widget's 'auto' savings format: the larger number of the two.
    if (pct >= off / 100) {
      return (strings.savings_percent || '{{ percent }}% Off').replace('{{ percent }}', pct);
    }
    return (strings.savings_amount || '{{ amount }} Off').replace('{{ amount }}', formatOmnibusMoney(off));
  }

  // Strip the widget's compare-at strike / savings, remembering the card's price
  // (cents, from the rendered results; digits of the price text as a fallback).
  function resetFfOmnibus(cards, prices) {
    cards.forEach(function (card) {
      var priceEl = card.querySelector('.ff-card-price');
      if (!priceEl || priceEl.dataset.ffOmnibus) return;
      var shown = priceEl.querySelector('.ff-price-sale') || priceEl.querySelector('span:not(.ff-price-savings)') || priceEl;
      var text = shown.textContent.trim();
      var cents = prices[card.dataset.productId];
      if (typeof cents !== 'number') cents = parseInt(text.replace(/\D/g, ''), 10);
      priceEl.dataset.ffOmnibus = 'true';
      priceEl.dataset.ffOmnibusPrice = String(cents);
      priceEl.dataset.ffOmnibusText = text;
      priceEl.className = 'ff-card-price';
      priceEl.textContent = text;
    });
  }

  // "Lowest price in 30 days: €X" (tile wording) under the card price, same look as
  // the product page note (snippets/omnibus-note.liquid), in ticked market countries only.
  function setFfOmnibusNote(priceEl, ref) {
    var note = priceEl.parentNode.querySelector('.ff-omnibus-note');
    var cfg = getConfig();
    var template = cfg.omnibusNote;
    // Only in market countries ticked in Theme settings (cfg.omnibusLabelCountries), by Shopify.country, not language
    var country = (window.Shopify && window.Shopify.country) || '';
    var labelOn = (cfg.omnibusLabelCountries || []).indexOf(country.toUpperCase()) !== -1;
    if (!ref || !template || !labelOn) {
      if (note) note.remove();
      return;
    }
    if (!note) {
      note = document.createElement('p');
      note.className = 'ff-omnibus-note';
      note.style.cssText = 'margin:4px 0 0;font-size:12px;line-height:1.4;color:#6b6b6b';
      priceEl.insertAdjacentElement('afterend', note);
    }
    note.textContent = template.replace('__PRICE__', formatOmnibusMoney(ref));
  }

  function applyFfOmnibus(cards, refs) {
    cards.forEach(function (card) {
      var priceEl = card.querySelector('.ff-card-price');
      if (!priceEl || !priceEl.dataset.ffOmnibus) return;
      // Code-discount cards are rewritten by decorateFfCodeDiscounts; leave them.
      if (priceEl.querySelector('.code-discount-text-coll')) return;
      var price = parseInt(priceEl.dataset.ffOmnibusPrice, 10);
      var text = priceEl.dataset.ffOmnibusText;
      // The ref of the variant the card is priced from (the cheapest one when Fitfindo prices cards that way).
      var ref = refs[card.dataset.priceVariantId || card.dataset.productId];
      if (typeof ref === 'number' && ref > price) {
        priceEl.className = 'ff-card-price ff-card-price--sale';
        priceEl.innerHTML =
          '<s class="ff-price-compare">' + formatOmnibusMoney(ref) + '</s>' +
          '<span class="ff-price-sale"></span>' +
          '<span class="ff-price-savings">' + omnibusSavingsText(ref, price) + '</span>';
        priceEl.querySelector('.ff-price-sale').textContent = text;
        setFfOmnibusNote(priceEl, ref);
      } else {
        priceEl.className = 'ff-card-price';
        priceEl.textContent = text;
        setFfOmnibusNote(priceEl, 0);
      }
    });
  }

  // The predictive search dropdown has no event and no variant on its rows, so
  // it never shows a reduction under Omnibus.
  function stripFfSuggestOmnibus(scope) {
    scope.querySelectorAll('.ff-suggest-price .ff-price-compare').forEach(function (el) {
      var row = el.parentNode;
      el.remove();
      row.classList.remove('ff-price-sale');
    });
  }

  function watchFfSuggestOmnibus() {
    if (!window.MutationObserver) return;
    new MutationObserver(function () {
      if (document.querySelector('.ff-suggest-price .ff-price-compare')) stripFfSuggestOmnibus(document);
    }).observe(document.body, { childList: true, subtree: true });
  }

  function decorateFitfindoGrid(root, results) {
    var scope = root && root.querySelectorAll ? root : document;
    var cards = Array.prototype.slice.call(scope.querySelectorAll('.ff-card'));
    if (!cards.length) return;

    var cfg = getConfig();
    var colorClass = 'color-' + (cfg.saleBadgeColorScheme || '');

    if (omnibusOn(cfg)) {
      var prices = {};
      (results || []).forEach(function (r) {
        if (r && r.product_id != null) prices[r.product_id] = r.price_amount;
      });
      resetFfOmnibus(cards, prices);
      if (omnibusRefs) {
        applyFfOmnibus(cards, omnibusRefs);
      } else {
        // Plain prices first; strike + Sale badge arrive with the refs.
        loadOmnibusRefs(cfg).then(function (refs) {
          applyFfOmnibus(cards, refs);
          decorateFfNativeBadges(cards, cfg);
        });
      }
    }

    decorateFfImageBadges(cards, cfg);
    decorateFfNativeBadges(cards, cfg);
    decorateFfSaleBadges(cards, cfg, colorClass);
    markPricedVariants(cards, results);
    decorateFfCodeDiscounts(cards, cfg, colorClass);
    decorateFfDiscountText(cards, cfg);
  }

  /* ------------------------------------------------------------------ *
   * Wiring
   * ------------------------------------------------------------------ */
  window.addEventListener('globoFilterRenderCompleted', decorateGloboGrid);

  document.addEventListener('fitfindo:rendered', function (e) {
    var grid = (e.detail && e.detail.grid) || document;
    decorateFitfindoGrid(grid, e.detail && e.detail.results);
  });

  // A swatch switches the card to another variant: its Omnibus ref may differ.
  document.addEventListener('fitfindo:swatch-selected', function (e) {
    var cfg = getConfig();
    if (!omnibusOn(cfg) || !e.detail) return;
    var card = document.querySelector('.ff-card[data-group-id="' + e.detail.display_group_id + '"]');
    if (!card) return;
    loadOmnibusRefs(cfg).then(function (refs) {
      applyFfOmnibus([card], refs);
      decorateFfNativeBadges([card], cfg);
    });
  });

  if (omnibusOn(getConfig())) {
    loadOmnibusRefs(getConfig());
    watchFfSuggestOmnibus();
  }

  // Handle the case where Fitfindo rendered before this deferred script ran.
  if (document.querySelector('.ff-card')) {
    decorateFitfindoGrid(document);
  }
})();
